<div class="content">
    <router-outlet></router-outlet>
    <app-loading *ngIf="loading"></app-loading>
</div>